<template>
  <div class="all-investment-cash-flow">
    <!-- 投资现金流量表 -->
    <div class="table-wrapper">
      <div class="table-scroll-area">
        <table class="profit-table">
          <thead>
            <tr>
              <th>序号</th>
              <th>项目</th>
              <th>合计</th>
              <th
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'header-' + index"
              >
                {{ index }}
              </th>
            </tr>
            <tr>
              <th class="seq-col"></th>
              <th style="text-align: center">建设期/经营期</th>
              <th class="total-col"></th>
              <th
                :colspan="localCashFlowData.constructionPeriod"
                style="font-size: 12px; color: #666; text-align: center"
              >
                建设期
              </th>
              <th
                :colspan="
                  localCashFlowData.calculationPeriod -
                  localCashFlowData.constructionPeriod
                "
                style="font-size: 12px; color: #666; text-align: center"
              >
                经营期
              </th>
            </tr>
          </thead>
          <tbody>
            <!-- 现金流入 -->
            <tr>
              <td class="seq-col">1</td>
              <td class="item-col">现金流入</td>
              <td class="total-col">
                {{
                  formatNumber(localCashFlowData.cashFlow.totalCashInflowsTotal)
                }}
              </td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'total-cash-inflows-' + index"
              >
                {{
                  formatNumber(
                    localCashFlowData.cashFlow.totalCashInflowsByYear[index - 1]
                  )
                }}
              </td>
            </tr>
            <tr>
              <td class="seq-col">1.1</td>
              <td class="item-col">营业收入</td>
              <td class="total-col">
                {{
                  formatNumber(localCashFlowData.cashFlow.operatingRevenueTotal)
                }}
              </td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'operating-revenue-' + index"
              >
                {{
                  formatNumber(
                    localCashFlowData.cashFlow.operatingRevenueByYear[index - 1]
                  )
                }}
              </td>
            </tr>
            <tr>
              <td class="seq-col">1.2</td>
              <td class="item-col">补贴收入</td>
              <td class="total-col">
                {{
                  formatNumber(localCashFlowData.cashFlow.subsidyIncomeTotal)
                }}
              </td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'subsidy-income-' + index"
              >
                {{
                  formatNumber(
                    localCashFlowData.cashFlow.subsidyIncomeByYear[index - 1]
                  )
                }}
              </td>
            </tr>
            <tr>
              <td class="seq-col">1.3</td>
              <td class="item-col">回收固定资产余值</td>
              <td class="total-col">
                {{
                  formatNumber(
                    localCashFlowData.cashFlow.recoveryFixedAssetsTotal
                  )
                }}
              </td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'recovery-fixed-assets-' + index"
              >
                {{
                  formatNumber(
                    localCashFlowData.cashFlow.recoveryFixedAssetsByYear[
                      index - 1
                    ]
                  )
                }}
              </td>
            </tr>
            <tr>
              <td class="seq-col">1.4</td>
              <td class="item-col">回收流动资金</td>
              <td class="total-col">
                {{
                  formatNumber(
                    localCashFlowData.cashFlow.recoveryWorkingCapitalTotal
                  )
                }}
              </td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'recovery-working-capital-' + index"
              >
                {{
                  formatNumber(
                    localCashFlowData.cashFlow.recoveryWorkingCapitalByYear[
                      index - 1
                    ]
                  )
                }}
              </td>
            </tr>

            <!-- 现金流出 -->
            <tr>
              <td class="seq-col">2</td>
              <td class="item-col">现金流出</td>
              <td class="total-col">
                {{
                  formatNumber(
                    localCashFlowData.cashFlow.totalCashOutflowsTotal
                  )
                }}
              </td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'total-cash-outflows-' + index"
              >
                {{
                  formatNumber(
                    localCashFlowData.cashFlow.totalCashOutflowsByYear[
                      index - 1
                    ]
                  )
                }}
              </td>
            </tr>
            <tr>
              <td class="seq-col">2.1</td>
              <td class="item-col">总投资</td>
              <td class="total-col">
                {{
                  formatNumber(localCashFlowData.cashFlow.totalInvestmentTotal)
                }}
              </td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'total-investment-' + index"
              >
                {{
                  formatNumber(
                    localCashFlowData.cashFlow.totalInvestmentByYear[index - 1]
                  )
                }}
              </td>
            </tr>
            <tr>
              <td class="seq-col">2.2</td>
              <td class="item-col">经营成本</td>
              <td class="total-col">
                {{
                  formatNumber(localCashFlowData.cashFlow.operatingCostsTotal)
                }}
              </td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'operating-costs-' + index"
              >
                {{
                  formatNumber(
                    localCashFlowData.cashFlow.operatingCostsByYear[index - 1]
                  )
                }}
              </td>
            </tr>
            <tr>
              <td class="seq-col">2.3</td>
              <td class="item-col">营业税金及附加</td>
              <td class="total-col">
                {{ formatNumber(localCashFlowData.cashFlow.businessTaxTotal) }}
              </td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'business-tax-' + index"
              >
                {{
                  formatNumber(
                    localCashFlowData.cashFlow.businessTaxByYear[index - 1]
                  )
                }}
              </td>
            </tr>
            <tr>
              <td class="seq-col">2.4</td>
              <td class="item-col">增值税</td>
              <td class="total-col">
                {{ formatNumber(localCashFlowData.cashFlow.vatTotal) }}
              </td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'vat-' + index"
              >
                {{
                  formatNumber(localCashFlowData.cashFlow.vatByYear[index - 1])
                }}
              </td>
            </tr>
            <tr>
              <td class="seq-col">2.5</td>
              <td class="item-col">所得税</td>
              <td class="total-col">
                {{ formatNumber(localCashFlowData.cashFlow.incomeTaxTotal) }}
              </td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'income-tax-' + index"
              >
                {{
                  formatNumber(
                    localCashFlowData.cashFlow.incomeTaxByYear[index - 1]
                  )
                }}
              </td>
            </tr>

            <!-- 净现金流量 -->
            <tr>
              <td class="seq-col">3</td>
              <td class="item-col">净现金流量</td>
              <td class="total-col">
                {{ formatNumber(localCashFlowData.cashFlow.netCashFlowTotal) }}
              </td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'net-cash-flow-' + index"
              >
                {{
                  formatNumber(
                    localCashFlowData.cashFlow.netCashFlowByYear[index - 1]
                  )
                }}
              </td>
            </tr>

            <!-- 折现净现金流量 -->
            <tr>
              <td class="seq-col">4</td>
              <td class="item-col">折现净现金流量</td>
              <td class="total-col">
                {{
                  formatNumber(
                    localCashFlowData.cashFlow.discountedNetCashFlowTotal
                  )
                }}
              </td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'discounted-net-cash-flow-' + index"
              >
                {{
                  formatNumber(
                    localCashFlowData.cashFlow.discountedNetCashFlowByYear[
                      index - 1
                    ]
                  )
                }}
              </td>
            </tr>

            <!-- 累计折现净现金流量 -->
            <tr>
              <td class="seq-col">5</td>
              <td class="item-col">累计折现净现金流量</td>
              <td class="total-col"></td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'cumulative-discounted-' + index"
              >
                {{
                  formatNumber(
                    localCashFlowData.cashFlow
                      .cumulativeDiscountedNetCashFlowByYear[index - 1]
                  )
                }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- 指标显示区 -->
    <div class="indicators-section">
      <!-- 净现值 -->
      <div class="indicator-group">
        <div class="indicator-title">净现值 (NPV) (万元)</div>
        <div class="indicator-item">
          <div class="indicator-label">税前：</div>
          <div class="indicator-value">
            {{
              formatNumber(
                localCashFlowData.cashFlow.discountedNetCashFlowTotalBeforeTax
              )
            }}
          </div>
        </div>
        <div class="indicator-item">
          <div class="indicator-label">税后：</div>
          <div class="indicator-value">
            {{
              formatNumber(
                localCashFlowData.cashFlow.discountedNetCashFlowTotal
              )
            }}
          </div>
        </div>
      </div>

      <!-- 内部收益率 -->
      <div class="indicator-group">
        <div class="indicator-title">内部收益率 (IRR) (%)</div>
        <div class="indicator-item">
          <div class="indicator-label">税前：</div>
          <div class="indicator-value">
            {{ formatPercent(localCashFlowData.cashFlow.irrBeforeTax) }}
          </div>
        </div>
        <div class="indicator-item">
          <div class="indicator-label">税后：</div>
          <div class="indicator-value">
            {{ formatPercent(localCashFlowData.cashFlow.irr) }}
          </div>
        </div>
      </div>

      <!-- 静态投资回收期 -->
      <div class="indicator-group">
        <div class="indicator-title">静态投资回收期 (年)</div>
        <div class="indicator-item">
          <div class="indicator-label">税前：</div>
          <div class="indicator-value">
            {{
              formatNumber(localCashFlowData.cashFlow.paybackPeriodBeforeTax, 1)
            }}
          </div>
        </div>
        <div class="indicator-item">
          <div class="indicator-label">税后：</div>
          <div class="indicator-value">
            {{ formatNumber(localCashFlowData.cashFlow.paybackPeriod, 1) }}
          </div>
        </div>
      </div>

      <!-- 动态投资回收期 -->
      <div class="indicator-group">
        <div class="indicator-title">动态投资回收期 (年)</div>
        <div class="indicator-item">
          <div class="indicator-label">税前：</div>
          <div class="indicator-value">
            {{
              formatNumber(
                localCashFlowData.cashFlow.discountedPaybackPeriodBeforeTax,
                1
              )
            }}
          </div>
        </div>
        <div class="indicator-item">
          <div class="indicator-label">税后：</div>
          <div class="indicator-value">
            {{
              formatNumber(
                localCashFlowData.cashFlow.discountedPaybackPeriod,
                1
              )
            }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { allInvestmentCashFlowCalculation, zongmove } from "@/utils/comp.js";

export default {
  name: "AllInvestmentCashFlow",
  data() {
    return {
      localCashFlowData: {
        cashFlow: {
          // 现金流入
          operatingRevenueByYear: [],
          operatingRevenueTotal: 0,
          subsidyIncomeByYear: [],
          subsidyIncomeTotal: 0,
          recoveryFixedAssetsByYear: [],
          recoveryFixedAssetsTotal: 0,
          recoveryWorkingCapitalByYear: [],
          recoveryWorkingCapitalTotal: 0,
          totalCashInflowsByYear: [],
          totalCashInflowsTotal: 0,

          // 现金流出
          totalInvestmentByYear: [],
          totalInvestmentTotal: 0,
          operatingCostsByYear: [],
          operatingCostsTotal: 0,
          businessTaxByYear: [],
          businessTaxTotal: 0,
          vatByYear: [],
          vatTotal: 0,
          incomeTaxByYear: [],
          incomeTaxTotal: 0,
          totalCashOutflowsByYear: [],
          totalCashOutflowsTotal: 0,

          // 净现金流量
          netCashFlowByYear: [],
          netCashFlowTotal: 0,

          // 折现净现金流量
          discountedNetCashFlowByYear: [],
          discountedNetCashFlowTotal: 0,
          cumulativeDiscountedNetCashFlowByYear: [],

          // 指标
          irr: 0,
          paybackPeriod: 0,
          discountedPaybackPeriod: 0,
        },
        calculationPeriod: 12,
        constructionPeriod: 1,
        operationPeriod: 11,
      },
    };
  },
  computed: {
    ...mapState(["projectData"]),
  },

  // 启动即调用计算函数
  created() {
    // 先执行所有依赖计算，确保数据完整
    this.$nextTick(() => {
      // 执行主要计算函数，确保所有依赖数据都已准备好，跳过分年投资计划计算
      zongmove();
      // 然后再执行当前组件的计算
      this.localCashFlowData = allInvestmentCashFlowCalculation();
      console.log(this.localCashFlowData);
    });
  },

  methods: {
    // 格式化数字显示
    formatNumber(num, decimalPlaces = 2) {
      if (num === null || num === undefined || isNaN(num)) {
        return "";
      }
      // 保留指定位数小数
      const formatted = num.toFixed(decimalPlaces);
      // 如果值为0，则显示为空
      if (parseFloat(formatted) === 0) {
        return "";
      }
      // 返回格式化后的数字，避免使用“...”
      return formatted;
    },

    // 格式化百分比显示
    formatPercent(num) {
      if (num === null || num === undefined || isNaN(num)) {
        return "";
      }
      // 保留2位小数并添加百分号
      const formatted = num.toFixed(2) + "%";
      // 如果值为0%，则显示为空
      if (parseFloat(num.toFixed(2)) === 0) {
        return "";
      }
      // 返回格式化后的百分比
      return formatted;
    },
  },
};
</script>

<style scoped>
.all-investment-cash-flow {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.table-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  /* 动态高度，确保表格不会超出视口 */
  min-height: 300px;
  max-height: calc(100vh - 200px);
  margin-bottom: 120px;
}

.table-scroll-area {
  flex: 1;
  overflow: auto;
  /* 支持水平和垂直滚动 */
  overflow-x: auto;
  overflow-y: auto;
  /* 确保滚动条可见 */
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 #f1f1f1;
}

/* 美化滚动条 */
.table-scroll-area::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.table-scroll-area::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.table-scroll-area::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.table-scroll-area::-webkit-scrollbar-thumb:hover {
  background: #a1a1a1;
}

.profit-table {
  /* 使用auto而不是fixed，让表格宽度根据内容自动调整 */
  table-layout: auto;
  border-collapse: collapse;
  font-size: 12px;
  /* 当列数少时，表格撑满容器宽度 */
  min-width: 100%;
  /* 确保表格内容不会被压缩 */
  white-space: nowrap;
}

.profit-table th,
.profit-table td {
  text-align: center;
  /* 缩小单元格边框 */
  border: 0.5px solid #dfe6ec;
  /* 设置文字不换行 */
  white-space: nowrap;
  overflow: visible;
  /* 确保不显示省略号 */
  text-overflow: clip;
}

.total-col,
.year-col {
  text-align: right !important;
  padding-right: 10px !important;
}

.profit-table thead th {
  background: #f8f9fa;
  font-weight: 600;
  position: sticky;
  top: 0;
  z-index: 10;
}

.seq-col {
  width: 50px;
  min-width: 50px;
}

.item-col {
  /* width: 200px;
  min-width: 200px; */
  text-align: left !important;
  padding-right: 10px !important;
  padding-left: 5px;
}

.total-col {
  width: 100px;
  min-width: 100px;
  font-weight: 600;
}

.year-col {
  padding: 4px 2px;
  min-width: 60px;
}

/* 指标显示区样式 */
.indicators-section {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #ffffff;
  border-top: 1px solid #dcdfe6;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  padding: 15px 20px;
  z-index: 100;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  gap: 30px;
}

/* 指标组样式 */
.indicator-group {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 150px;
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

/* 指标组悬停效果 */
.indicator-group:hover {
  background-color: #e3f2fd;
  border-color: #90caf9;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

/* 指标标题 */
.indicator-title {
  font-size: 13px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 8px;
  text-align: center;
}

/* 指标项样式 */
.indicator-item {
  display: flex;
  justify-content: space-around;
  width: 100%;
  margin-bottom: 4px;
}

.indicator-label {
  font-size: 12px;
  color: #606266;
  flex: 1;
  text-align: center;
}

.indicator-value {
  font-size: 12px;
  font-weight: 600;
  color: #303133;
  flex: 1;
  text-align: center;
}
</style>
